import { CmsCustomPackage, extendComponentDefinitions } from '@grandvisionhq/bloomreach'
import { ComparisonSlider } from '@grandvisionhq/pblx-comparison-slider'
import { Tabs } from '@grandvisionhq/pblx-tabs'
import { BriladviesTool } from '@grandvisionhq/pnl-briladviestool'
// Custom packages go here
import { StoreLists } from '@grandvisionhq/pnl-store-lists'

export const customComponents = {
  briladviestool: { type: BriladviesTool },
  'briladviestool-open': { type: BriladviesTool, props: { config: { openOnInit: true } } },
  'store-list-all': { type: StoreLists },
  'store-list-onehourservice': {
    type: StoreLists,
    props: { config: { filterKey: 'u_smd_onehourservice' } },
  },
  'store-list-nightlenses': {
    type: StoreLists,
    props: { config: { filterKey: 'u_smd_nightlenses' } },
  },
  'store-list-optometry': { type: StoreLists, props: { config: { filterKey: 'u_smd_optometry' } } },
  'comparison-slider-nightview': { type: ComparisonSlider, props: { type: 'nightview' } },
  'comparison-slider-sunglasses': { type: ComparisonSlider, props: { type: 'sunglasses' } },
  'comparison-slider-roadview': { type: ComparisonSlider, props: { type: 'roadview' } },
  'comparison-slider-polarized': { type: ComparisonSlider, props: { type: 'polarized' } },
  'tabs-kleurenblindheid': { type: Tabs, props: { type: 'kleurenblindheid' } },
  'tabs-brilreparatie': { type: Tabs, props: { type: 'brilreparatie' } },
}

export const componentDefinitions = extendComponentDefinitions({
  'Custom Package': CmsCustomPackage,
})
